import React from 'react';

export const Logo = ({ className = "h-10", showText = true, textClassName = "" }) => {
  return (
    <div className="flex items-center gap-3">
      <img 
        src="/logo.webp" 
        alt="Simplif-i" 
        className={className}
        width="40"
        height="40"
        style={{ objectFit: 'contain' }}
        loading="eager"
        fetchPriority="high"
        decoding="async"
      />
      {showText && (
        <span className={`font-semibold text-xl tracking-tight whitespace-nowrap ${textClassName}`}>
          Simplif-i
        </span>
      )}
    </div>
  );
};

export const LogoIcon = ({ className = "h-10" }) => {
  return (
    <img 
      src="/logo.webp" 
      alt="Simplif-i" 
      className={className}
      width="40"
      height="40"
      style={{ objectFit: 'contain' }}
      loading="eager"
      decoding="async"
    />
  );
};

export default Logo;
